'use strict';

/* global $ */

import { getAjax } from '../utils/ajax';

function GetProd(options) {

    let settings = {
        formSelector: '.js-product-filter',
        typeSelector: '.js-product-filter-type',
        fieldSelector: '.js-product-filter-field',
        blockSelector: '.js-filter-block'
    };

    let opt = $.extend({}, settings, options);
    let form = opt.formSelector,
        type = opt.typeSelector,
        field = opt.fieldSelector,
        block = opt.blockSelector;

    $(form).submit(function(e) {
        e.preventDefault();
        let form = $(this);
        let data = {};
        data = form.data();
        data.filters = [];
        $(type).each(function() {
            if ($(this).data('type') == 'number'){

            } else {
                let fields = $(this).find($(field));
                fields.each(function() {
                    if ($(this).prop('checked')) {
                        data.filters.push($(this).attr('id')); 
                    }
                });
            }

        });

        getAjax('get_prod', data).then(function(data) {
            if (data.ok) {
                $(block).html(data.content);
            } else {
                console.error('Can\'t get form');
            }
        }).catch(function(error) {
            throw new Error(error);
        });

    });
    
    $(form).on("click", "input[type='reset']", function(e){

        let form = $("form");
        let data = {};
        
        form.trigger("reset");
        data = form.data();
        data.filters = [];
        getAjax('get_prod', data).then(function(data) {
            if (data.ok) {
                $(block).html(data.content);
            } else {
                console.error('Can\'t get form');
            }
        }).catch(function(error) {
            throw new Error(error);
        });
    });

    $(form).on("click", field, function(e){
        let $form = $(this)[0].form;
        let data = $($form).data();
        data.filters = [];
        $(type).each(function() {
            if ($(this).data('type') == 'number'){

            } else {
                let fields = $(this).find($(field));
                fields.each(function() {
                    if ($(this).prop('checked')) {
                        data.filters.push($(this).attr('id')); 
                    }
                });
            }

        });
        getAjax('get_prod', data).then(function(data) {
            if (data.ok) {
                $(block).html(data.content);
            } else {
                console.error('Can\'t get form');
            }
        }).catch(function(error) {
            throw new Error(error);
        });
    });
}

export {
    GetProd
};
